// extracted by mini-css-extract-plugin
export default {"wrapper":"dpiaHeader_wrapper__X90hS","cnt":"dpiaHeader_cnt__98E22","search":"dpiaHeader_search__J6TDd","label":"dpiaHeader_label__S2fAy","txt":"dpiaHeader_txt__Th4Gx"};